// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"49b5c15509ac136ae8cb","883":"a2c2092b87b44734b361"}[chunkId] + ".js";
};